import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from 'src/@shared/shared/common-pages.service';
import {
  ResponseResultAccounts,
  ResponseResultRecords,
  ResponseResultSites,
} from 'src/models/user.model';
import { responseMessageStatus, ResponseStatus } from '../../enum';
interface Roles {
  id: string;
  name: string;
  description: string;
}
@Component({
    selector: 'app-add-update-user',
    templateUrl: './add-update-user.component.html',
    styleUrls: ['./add-update-user.component.scss'],
    standalone: false
})
export class AddUpdateUserComponent implements OnInit {
  //#region properties
  accountsData: any[] = [];
  sitesData: any[] = [];
  isVisibleUserDrawer = true;
  userDrawerTitle: any;
  @Output() hideUserDrawer = new EventEmitter();
  @Input() selectedData: ResponseResultRecords;
  listOfRoles: Roles[] = [];
  isLoadingUser: boolean = false;
  selectedAccounts: Array<ResponseResultAccounts> = [];
  selectedSites: Array<ResponseResultSites> = [];
  currentUserDetails: any;
  showAccountsInvalidMessage: boolean = false;
  showSitesInvalidMessage: boolean = false;
  show2FAToggle: boolean = false;
  sitesDataCopy: Array<ResponseResultSites> = [];
  descriptionToShow: string = '';
  accountsArrayToPass: Array<ResponseResultAccounts> = [];
  agencyDetails: any;
  //#endregion

  //constructor
  constructor(
    public _cs: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.userForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    const sessionCurrentAgency = JSON.parse(
      sessionStorage.getItem('AgencyDetails') || '{}'
    );
    this.agencyDetails = {
      id: sessionCurrentAgency._id,
      name: sessionCurrentAgency.Name,
    };
    // this.getAccountsSitesData();
    //get roles
    this._cpS.paybevRoles.length == 0
      ? this.getAllRoles()
      : (this.listOfRoles = this._cpS.paybevRoles);
    //while edit change modal title
    if (this.selectedData != null) {
      this.userDrawerTitle = 'Edit User';

      this._fS.userForm.patchValue({
        firstName: this.selectedData.firstName,
        lastName: this.selectedData.lastName,
        emailAddress: this.selectedData.email,
        role: this.selectedData.role,
        isUserActive: this.selectedData.isActive,
        phoneNumber: this.selectedData.phoneNumber,
      });
     
      this.getAllSitesWithAcc(this.accountsData, 'PATCH');
    } else {
      this.userDrawerTitle = 'Add User';
      this.getAllSitesWithAcc(this.accountsData, 'GET');
    }
  }

  patchAccountsSites() {
    this.accountsData.forEach((account: any) => {
      this.selectedData.accounts.forEach((acc: any) => {
        if (acc.name == account.text) {
          account['checked'] = true;
        }
      });
    });
    this.accountsChanged(this.accountsData);
    if (this.selectedData != null) {
      this.sitesData.forEach((site: any) => {
        site.children.forEach((element: any) => {
          this.selectedData.sites.forEach((siteItem: any) => {
            if (siteItem.name == element.text) {
              element['checked'] = true;
              this.selectedSites.push(siteItem);
            }
          });
        });
      });
    }
  }

  accountsChanged(event: any) {
    this.sitesData.forEach((element: any) => {
      element.parent['checked'] = false;
      element.children.map((site: any) => (site.checked = false));
    });
    this.selectedSites = [];
    const checkedAccounts = event.filter((x: any) => x.checked == true);
    if (checkedAccounts.length > 0) {
      this.showAccountsInvalidMessage = false;
    } else {
      this.showAccountsInvalidMessage = true;
    }
    this.selectedAccounts = checkedAccounts.map((account: any) => {
      return { id: account.value, name: account.text };
    });
    let accountNames: any[] = [];
    accountNames = this.selectedAccounts.map((acc: any) => acc.name);
    this.sitesData = this.sitesDataCopy.filter((site: any) =>
      accountNames.includes(site.parent.text)
    );
    this.sitesData = [...this.sitesData];
  }
  sitesChanged(event: any) {
    this.selectedSites = [];
    this.accountsArrayToPass = [];
    event.forEach((element: any) => {
      element.children.forEach((child: any) => {
        if (child.checked == true) {
          this.selectedSites.push({ id: child.value, name: child.text });
          if (!this.accountsArrayToPass.includes(child.accountId)) {
            this.accountsArrayToPass.push({
              id: child.accountId,
              name: child.accountName,
            });
          }
        }
      });
    });
    if (this.selectedSites.length > 0) {
      this.showSitesInvalidMessage = false;
    } else {
      this.showSitesInvalidMessage = true;
    }
  }
  //to get states from db
  getAllRoles() {
    this._cpS.getRoles().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfRoles = response.result.roleItems;
        if(!this.selectedData){
        this.listOfRoles = response.result.roleItems.filter(
          (x: any) => x.name !== 'Supplier Admin (Wine.com)'
        );
      }else{
         const selectedRole = this.listOfRoles.find(
        (role: any) => role.id == this.selectedData.role
      );
      this.descriptionToShow = selectedRole?.description ? selectedRole?.description : '';
      if (selectedRole?.name == 'Supplier Admin (Wine.com)') {
        //disable role selection for supplier admin
        this._fS.userForm.get('role')?.disable();
      }
      }
      
         this._cpS.paybevRoles = this.listOfRoles;
      }
    });
  }

  //close drawer
  handleCancel() {
    this.isVisibleUserDrawer = false;
    this.hideUserDrawer.emit({ hide: this.isVisibleUserDrawer, data: null });
  }

  //add or update button of drawer clicked
  handleOk() {
    console.log(this.selectedSites);
    
    if (this._fS.userForm.valid && this.selectedSites.length > 0) {
      this.isLoadingUser = true;
      let sitesNames: any[] = [];
      sitesNames = this.selectedSites.map((site: any) => {
        return { id: site.id, name: site.name };
      });

      //enable role field if disabled before getting value
      this._fS.userForm.get('role')?.enable();

      const formValue = this._fS.userForm.value;
      const userBody: any = {
        firstName: formValue.firstName,
        lastName: formValue.lastName,
        email: formValue.emailAddress,
        role: formValue.role,
        agency: [this.agencyDetails],
        twoFactorEnabled: false,
        phoneNumber: formValue.phoneNumber,
        suppliers: this.accountsArrayToPass,
        isForcePasswordChange: false,
        reps: sitesNames,
        isActive: formValue.isUserActive,
      };
      //add or edit user data
      if (this.selectedData == null) {
        this.addUserData(userBody);
      } else {
        userBody['id'] = this.selectedData.id;
        this.editUserData(userBody);
      }
    } else {
      //to fire validations on invalid fields
      this._cs.markFormGroupTouched(this._fS.userForm);
      if (this.selectedSites?.length == 0) {
        this.showSitesInvalidMessage = true;
      }
    }
  }

  editUserData(userBody: any) {
    this._cpS.EditUser(userBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cs.displayMessage(
          responseMessageStatus.success,
          response.message
        );
        //hide unit drawer
        this.isLoadingUser = false;
        this.isVisibleUserDrawer = false;

        const dataToupdate = {
          firstName: response.result.firstName,
          lastName: response.result.lastName,
          role: response.result.role,
          roles: response.result.roles[0],
          email: response.result.email,
          isActive: response.result.isActive,
          phoneNumber: response.result.phoneNumber,
          suppliers: response.result.suppliers,
          reps: response.result.reps,
          id: response.result.id,
          invitationStatus: response.result.invitationStatus,
        };
        this.hideUserDrawer.emit({
          hide: this.isVisibleUserDrawer,
          data: dataToupdate,
        });
      } else {
        this.isLoadingUser = false;
        this._cs.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  //add or update date on buttton click
  addUserData(userBody: any) {
    this._cpS.createUser(userBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cs.displayMessage(
          responseMessageStatus.success,
          response.message
        );
        //hide unit drawer
        this.isLoadingUser = false;
        this.isVisibleUserDrawer = false;

        // update to outer users list
        const userDetails = response.result;
        const dataToupdate = {
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          roles: userDetails.roles[0],
          role: userDetails.role,
          email: userDetails.email,
          isActive: userDetails.isActive,
          phoneNumber: userDetails.phoneNumber,
          accounts: userDetails.suppliers,
          sites: userDetails.reps,
          id: userDetails.id,
          invitationStatus: userDetails.invitationStatus,
        };
        this.hideUserDrawer.emit({
          hide: this.isVisibleUserDrawer,
          data: dataToupdate,
        });
      } else {
        this.isLoadingUser = false;
        this._cs.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  onSelectRole(option: any) {
    const selectedRole = this.listOfRoles.find(
      (role: any) => role.id == option
    );
    this.descriptionToShow = selectedRole.description;
  }
  sitesDropdownChanged(event: any) {
    this.selectedSites = [];
    this.accountsArrayToPass = [];
    event.forEach((element: any) => {
      if (element.parent.checked == true) {
        this.accountsArrayToPass.push({
          id: element.parent.id,
          name: element.parent.name,
          isSelected: true,
        });
      }
      element.children.forEach((child: any) => {
        if (child.checked == true) {
          this.selectedSites.push({ id: child.id, name: child.name });
          this.accountsArrayToPass.push({
            id: child.accountId,
            name: child.accountName,
          });
        }
      });
    });
    this.accountsArrayToPass = this.accountsArrayToPass.reduce((unique, o) => {
      if (!unique.some((obj: any) => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    }, []);
    this._fS.userForm.patchValue({
      sites: this.selectedSites,
    });
    if (this.selectedSites.length > 0) {
      this.showSitesInvalidMessage = false;
    } else {
      this.showSitesInvalidMessage = true;
    }
  }
  getAllSitesWithAcc(event: any, type: any) {
    this._cpS.getSuppliersForUser().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.sitesData = response.result;
        //filter sitesData with no children
        this.sitesData = this.sitesData.filter((x:any)=>x.children.length);
        if (type == 'PATCH') {
          // let count = 0;
          this.selectedSites = this.selectedData.sites;
          this.selectedData.reps.forEach((el: any) => {
            this.sitesData.map((parentelement: any) => {
              parentelement.children.map((childelement: any) => {
                if (el.id == childelement.id) {
                  childelement.checked = true;
                  childelement.search = true;
                  this.accountsArrayToPass.push({
                    id: childelement.accountId,
                    name: parentelement.parent,
                  });
                }
              });
            });
          });
          this.sitesData.map((parentelement: any) => {
            parentelement.children.map((childelement: any) => {
              if (childelement.checked == true) {
                // count++;
              }
            });
            parentelement['parent'] = {
              name: parentelement.parent,
              id: parentelement.children[0].accountId,
              search: true,
              checked: false,
            };
          });
          this.selectedData.suppliers?.forEach((element: any) => {
            if (element.isSelected == true) {
              this.sitesData.map((item: any) => {
                if (item.parent.id == element.id) {
                  item.parent.checked = true;
                  this.accountsArrayToPass.push({
                    id: item.parent.id,
                    name: item.parent.name,
                    isSelected: true,
                  });
                }
              });
              this.sitesData = [...this.sitesData];
            }
          });
          const tempArray: any = [];
          const accountIds: any = [];
          this.accountsArrayToPass.forEach((element: any) => {
            if (element.isSelected) {
              tempArray.push(element);
              accountIds.push(element.id);
            }
          });
          this.accountsArrayToPass.forEach((element: any) => {
            if (!element.isSelected) {
              if (!accountIds.includes(element.id)) {
                tempArray.push(element);
                accountIds.push(element.id);
              } else {
                accountIds.push(element.id);
              }
            }
          });
          this.accountsArrayToPass = tempArray;
          this.sitesDropdownChanged(this.sitesData);
        } else if (type == 'GET') {
          this.sitesData.map((el: any) => {
            if(el.children){
            el.children.map((e: any) => {
              {
                e.search = true;
                e.checked = false;
              }
            });
            el['parent'] = {
              name: el.parent,
              id: el.children[0].accountId,
              search: true,
              checked: false,
            };
            }
          });
        }
      }
    });
  }
  //#endregion
}
